import React from "react";

export const authDE: AuthResourcesInterface = {
  title: "Titel",
  aboutMeDescription: () => <React.Fragment>Ein Element</React.Fragment>,
  registerButton: "Registrieren",
  errors: {
    loginError:
      "Beim Login ist ein Fehler aufgetreten. Bitte überprüfen Sie, ob Ihre E-Mail und Ihr Passwort korrekt sind. Falls das Problem weiterhin besteht, kontaktieren Sie den Administrator.",
    register:
      "Kontoerstellung fehlgeschlagen. Die von Ihnen eingegebene E-Mail war bereits registriert oder es gab ein anderes Problem. Bitte kontaktieren Sie den Administrator.",
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
    emailNotFound: "Ihr Konto wurde nicht gefunden",
    emailFound:
      "Bitte überprüfen Sie Ihre E-Mail und geben Sie das einmalige Passwort ein, das Sie erhalten haben.",
    errorPsw:
      "Beim Aktualisieren Ihres Passworts ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    errorCaptcha:
      "Bei der Überprüfung ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu. Falls der Fehler weiterhin auftritt, kontaktieren Sie den Administrator.",
  },
  login: {
    title:
      "Geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein, um auf das Nachweis-System zuzugreifen",
    email: "E-Mail",
    emailError: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    passwordError: "Bitte geben Sie ein gültiges Passwort ein",
    password: "Passwort",
    button: "Zugang",
    emailPlaceholder: "E-Mail-Adresse eingeben",
    passwordPlaceholder: "Passwort eingeben",
    bottom: {
      forgot: "Passwort vergessen?",
      signup: "Registrieren",
      donthave: "Haben Sie kein Konto?",
    },
  },
  confirm: {
    title: "Erfolgreich!",
    email: "E-Mail wurde gesendet an ",
    checkEmail:
      ". Bitte überprüfen Sie die E-Mail, die Sie erhalten haben, und klicken Sie auf den Link in der Nachricht, um Ihr Passwort zurückzusetzen.",
    back: "Zurück zur Anmeldung",
  },
  forgetPassword: {
    modal: {
      title: "Erfolgreich",
      text: "Sie haben Ihre Daten erfolgreich geändert.",
      button: "Fertig",
    },
    checkTempButton: "Neues Passwort speichern",
    email: {
      label: "E-Mail",
      name: "email",
      error: "Gültige E-Mail eingeben",
      validation: "Ungültige E-Mail",
      placeholder: "Gültige E-Mail eingeben",
    },
    tempPassword: {
      label: "Einmaliges Passwort",
      name: "tempPassword",
      error: "Bitte geben Sie Ihr einmaliges Passwort ein.",
      placeholder: "Geben Sie Ihr einmaliges Passwort ein.",
    },
    password: {
      label: "Passwort",
      name: "password",
      error: "Gültiges Passwort eingeben",
      validation: "Ungültiges Passwort",
    },
    passwordRepeat: {
      label: "Passwort wiederholen",
      name: "repeatPassword",
      error: "Bitte wiederholen Sie die Passwort-Eingabe",
      validation: "Ungültiges Passwort",
      matchError: "Ihr Passwort ist nicht korrekt",
    },
    title:
      "Geben Sie Ihre E-Mail-Adresse ein, an die wir Ihnen Anweisungen zum Ändern Ihres Passworts senden werden.",
    changeButton: "Passwort zurücksetzen",
    findButton: "Benutzer finden",
    login: {
      description: "Erinnern Sie sich an Ihr Passwort?",
      button: "Anmelden!",
    },
    register: {
      description: "Haben Sie kein Konto?",
      button: "Registrieren!",
    },
  },
  logout: {
    back: "Zurück zur",
    backButton: "Anmeldung",
    title: "Bis bald!",
    description: "Sie haben sich erfolgreich abgemeldet!",
  },
};

interface FieldValidation {
  label: string;
  name: string;
  error: string;
  validation?: string;
  placeholder?: string;
  matchError?: string;
}

interface Modal {
  title: string;
  text: string;
  button: string;
}

interface ForgetPassword {
  title: string;
  email: FieldValidation;
  password: FieldValidation;
  passwordRepeat: FieldValidation;
  tempPassword: FieldValidation;
  findButton: string;
  checkTempButton: string;
  changeButton: string;
  login: {
    description: string;
    button: string;
  };
  register: {
    description: string;
    button: string;
  };
  modal: Modal;
}

interface ErrorFields {
  loginError: string;
  register: string;
  registerPic: string;
  emailNotFound: string;
  emailFound: string;
  errorPsw: string;
  errorCaptcha: string;
}

export interface AuthResourcesInterface {
  title: string;
  aboutMeDescription: () => JSX.Element;
  registerButton: string;
  login: {
    title: string;
    email: string;
    password: string;
    emailError: string;
    emailPlaceholder: string;
    passwordError: string;
    passwordPlaceholder: string;
    button: string;
    bottom: {
      forgot: string;
      signup: string;
      donthave: string;
    };
  };
  confirm: {
    title: string;
    email: string;
    checkEmail: string;
    back: string;
  };
  forgetPassword: ForgetPassword;
  logout: {
    back: string;
    backButton: string;
    title: string;
    description: string;
  };
  errors: ErrorFields;
}
